Vue.use(Vuex)

import param from './modules/parameter'

//定义容器
let store = new Vuex.Store({
	modules:{
		param: param,
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js